import React from 'react'
import IconPng from 'atoms/IconPng'
import { MainWrapper } from './styles'

const gifSrc = require('App/assets/images/loader.gif')

const LoaderModalContent = () => {
  return (
    <MainWrapper>
      <IconPng src={gifSrc} size={'57'} h={'auto'} />
    </MainWrapper>
  )
}

export default LoaderModalContent
